import ArrowIcon from '../icons/arrow.svelte';
import CashbackIcon from '../icons/cashbackIcon.svg';
import CasinoIcon from '../icons/casino.svelte';
import CCIcon from '../icons/cc.svelte';
import ChatIcon from '../icons/chat.svelte';
import ChatsIcon from '../icons/chats.svelte';
import CheckIcon from '../icons/check.svelte';
import ClockIcon from '../icons/clock.png';
import CloseIcon from '../icons/close.svg';
import CopyIcon from '../icons/copy.svelte';
import DiscordIcon from '../icons/discord.svelte';
import DropArrow from '../icons/drop-arrow.svg';
import FacebookIcon from '../icons/facebook.svelte';
import InstagramIcon from '../icons/instagram.svelte';
import DropdownArrowIcon from '../icons/dropdown_arrow.svelte';
import EmailIcon from '../icons/email.svelte';
import ErrorIcon from '../icons/error.png';
import FlushVIPClubIcon from '../icons/eventsClubIcon.svg';
import EventsIcon from '../icons/eventsIcon.svg';
import EventsPartyIcon from '../icons/eventsPartyIcon.svg';
import EventsTicketsIcon from '../icons/eventsTicketsIcon.svg';
import EyeIcon from '../icons/eye.svelte';
import EyeSlashIcon from '../icons/eyeslash.svelte';
import ElitePerksIcon from '../icons/featureEliteIcon.svg';
import FreeSpinsIcon from '../icons/freeSpinsIcon.svg';
import WalletGameIcon from '../icons/game-wallet.svelte';
import GifIcon from '../icons/gif.svelte';
import GiftIcon from '../icons/gift.svelte';
import GoBackIcon from '../icons/goback.svelte';
import GoogleIcon from '../icons/google.svg';
import HappyFaceIcon from '../icons/happyFace.svelte';
import FeatureBuyInIcon from '../icons/icons-flush/feature-buyin.svelte';
import GameShowsIcon from '../icons/icons-flush/game-shows.svelte';
import LiveCasinoIcon from '../icons/icons-flush/live-casino.svelte';
import NewGamesIcon from '../icons/icons-flush/newgames.svelte';
import OriginalsIcon from '../icons/icons-flush/originals.svelte';
import PopularIcon from '../icons/icons-flush/popular.svelte';
import ProvidersIcon from '../icons/icons-flush/providers.svelte';
import SlotsIcon from '../icons/icons-flush/slots.svelte';
import SportsCasinoIcon from '../icons/icons-flush/sports.svelte';
import IncorrectIcon from '../icons/incorrect.svelte';
import InfoIcon from '../icons/info.svelte';
import InteractIcon from '../icons/interact.svelte';
import LeftIcon from '../icons/left.svg';
import LinkIcon from '../icons/link.svg';
import LockIcon from '../icons/lock.svelte';
import MailIcon from '../icons/mail.svg';
import MediaContentIcon from '../icons/mediaContentIcon.svelte';
import MediaContentUploadIcon from '../icons/mediaContentUploadIcon.svelte';
import MetaMaskIcon from '../icons/metamask.svelte';
import NextPaginatorIcon from '../icons/next-paginator-icon.svg';
import NotificationsIcon from '../icons/notifications.svelte';
import PlayIcon from '../icons/play-icon.svg';
import PreviousPaginatorIcon from '../icons/previous-paginator-icon.svg';
import PromotionsIcon from '../icons/promotions.svg';
import QuestIcon from '../icons/quest.svelte';
import QuestionIcon from '../icons/question.svelte';
import RacesIcon from '../icons/races.svelte';
import ReadIcon from '../icons/read.svg';
import RedditIcon from '../icons/reddit.svelte';
import RefreshIcon from '../icons/refresh.svelte';
import RemoveIcon from '../icons/remove.svelte';
import RightIcon from '../icons/right.svg';
import SaveIcon from '../icons/save.svelte';
import ScrollUpIcon from '../icons/scroll-up.svg';
import SearchIcon from '../icons/search.svg';
import ShareIcon from '../icons/share.svg';
import SpinIcon from '../icons/spin.svelte';
import SportsIcon from '../icons/sports.svelte';
import StarIcon from '../icons/starIcon.svg';
import SuccessIcon from '../icons/success.png';
import SupportIcon from '../icons/support.svelte';
import SwitchIcon from '../icons/switch.svelte';
import AllGamesTabIcon from '../icons/tabs/all-games.svelte';
import FavoritesTabIcon from '../icons/tabs/favorites.svelte';
import FeatureBuyInTabIcon from '../icons/tabs/feature-buyin.svelte';
import GameShowsTabIcon from '../icons/tabs/game-shows.svelte';
import LiveCasinoTabIcon from '../icons/tabs/live-casino.svelte';
import NewGamesTabIcon from '../icons/tabs/newgames.svelte';
import OriginalsTabIcon from '../icons/tabs/originals.svelte';
import PopularTabIcon from '../icons/tabs/popular.svelte';
import RecentlyTabIcon from '../icons/tabs/recently.svelte';
import SlotsTabIcon from '../icons/tabs/slots.svelte';
import TelegramIcon from '../icons/telegram.svelte';
import TestimonialsIcon from '../icons/testimonialsIcon.svg';
import { default as TickIcon, default as TickIconAlternative } from '../icons/tick.svg';
import TradingIcon from '../icons/trading.svelte';
import TransparencyIcon from '../icons/transparency.svelte';
import TrashIcon from '../icons/trash.svg';
import UnlockIcon from '../icons/unlock.svg';
import UpIcon from '../icons/up.png';
import UserIcon from '../icons/user.svelte';
import VipHeaderIcon from '../icons/vip-header.svelte';
import VipIcon from '../icons/vip.svelte';
import WalletMobileIcon from '../icons/wallet-mobile.svelte';
import WalletIcon from '../icons/wallet.svelte';
import WalletConnectIcon from '../icons/walletconnect.svelte';
import WarningSmallIcon from '../icons/warning-small.svelte';
import WarningIcon from '../icons/warning.svelte';
import WarningNewIcon from '../icons/warning_new.svelte';
import XIcon from '../icons/x.svelte';
import YoutubeIcon from '../icons/youtube.svelte';
import { cfgCdnBase, cfgToThemeCdnPath } from '@infinitro/config';
const CDN_BASE = cfgCdnBase();
export const flushIcons = {
    OriginalsIcon: OriginalsIcon,
    PopularIcon: PopularIcon,
    ProviderIcon: ProvidersIcon,
    NewGamesIcon: NewGamesIcon,
    GameShowsIcon: GameShowsIcon,
    FeatureBuyInIcon: FeatureBuyInIcon,
    LiveCasinoIcon: LiveCasinoIcon,
    SportsIcon: SportsCasinoIcon,
    SlotsIcon: SlotsIcon,
    TradingIcon: TradingIcon,
    SupportIcon: SupportIcon,
    CasinoIcon: CasinoIcon,
    QuestIcon: QuestIcon,
    SpinIcon: SpinIcon,
    SearchIcon: SearchIcon,
    DropdownArrowIcon: DropdownArrowIcon,
    AllGamesTabIcon: AllGamesTabIcon,
    FavoritesTabIcon: FavoritesTabIcon,
    LiveCasinoTabIcon: LiveCasinoTabIcon,
    NewGamesTabIcon: NewGamesTabIcon,
    OriginalsTabIcon: OriginalsTabIcon,
    PopularTabIcon: PopularTabIcon,
    GameShowsTabIcon: GameShowsTabIcon,
    FeatureBuyInTabIcon: FeatureBuyInTabIcon,
    RecentlyTabIcon: RecentlyTabIcon,
    SlotsTabIcon: SlotsTabIcon,
    SportsSidebarIcon: SportsIcon,
    CloseIcon: CloseIcon,
    ArrowIcon: ArrowIcon,
    DropdownIcon: DropdownArrowIcon,
    CopyIcon: CopyIcon,
    DropArrow: DropArrow,
    ShareIcon: ShareIcon,
    TrashIcon: TrashIcon,
    RedditIcon: RedditIcon,
    TelegramIcon: TelegramIcon,
    XIcon: XIcon,
    FacebookIcon: FacebookIcon,
    InstagramIcon: InstagramIcon,
    YoutubeIcon: YoutubeIcon,
    NextPaginatorIcon: NextPaginatorIcon,
    PreviousPaginatorIcon: PreviousPaginatorIcon,
    ErrorIcon: ErrorIcon,
    InfoIcon: InfoIcon,
    SuccessIcon: SuccessIcon,
    WarningIcon: WarningIcon,
    WarningNewIcon: WarningNewIcon,
    ClockIcon: ClockIcon,
    CCIcon: CCIcon,
    ChatsIcon: ChatsIcon,
    CheckIcon: CheckIcon,
    DiscordIcon: DiscordIcon,
    EyeIcon: EyeIcon,
    EyeSlashIcon: EyeSlashIcon,
    GifIcon: GifIcon,
    GiftIcon: GiftIcon,
    GoBackIcon: GoBackIcon,
    GoogleIcon: GoogleIcon,
    HappyFaceIcon: HappyFaceIcon,
    IncorrectIcon: IncorrectIcon,
    InteractIcon: InteractIcon,
    LeftIcon: LeftIcon,
    LinkIcon: LinkIcon,
    LockIcon: LockIcon,
    MediaContentIcon: MediaContentIcon,
    MediaContentUploadIcon: MediaContentUploadIcon,
    MetaMaskIcon: MetaMaskIcon,
    NotificationsIcon: NotificationsIcon,
    QuestionIcon: QuestionIcon,
    RacesIcon: RacesIcon,
    ReadIcon: ReadIcon,
    RefreshIcon: RefreshIcon,
    RemoveIcon: RemoveIcon,
    RightIcon: RightIcon,
    SaveIcon: SaveIcon,
    CashbackIcon: CashbackIcon,
    FlushVIPClubIcon: FlushVIPClubIcon,
    EventsIcon: EventsIcon,
    EventsPartyIcon: EventsPartyIcon,
    EventsTicketsIcon: EventsTicketsIcon,
    ElitePerksIcon: ElitePerksIcon,
    FreeSpinsIcon: FreeSpinsIcon,
    PlayIcon: PlayIcon,
    StarIcon: StarIcon,
    TestimonialsIcon: TestimonialsIcon,
    EmailIcon: EmailIcon,
    SwitchIcon: SwitchIcon,
    WalletIcon: WalletIcon,
    WalletMobileIcon: WalletMobileIcon,
    WalletConnectIcon: WalletConnectIcon,
    WarningSmallIcon: WarningSmallIcon,
    TickIcon: TickIcon,
    TickIconAlternative: TickIconAlternative,
    UnlockIcon: UnlockIcon,
    UpIcon: UpIcon,
    UserIcon: UserIcon,
    VipIcon: VipIcon,
    PromotionsIcon: PromotionsIcon,
    MailIcon: MailIcon,
    ChatIcon: ChatIcon,
    VipHeaderIcon: VipHeaderIcon,
    WalletGameIcon: WalletGameIcon,
    ScrollUpIcon: ScrollUpIcon,
    TransparencyIcon: TransparencyIcon,
    ChatIconComment: cfgToThemeCdnPath('/comments/Chat.png'),
    LikeIconComment: cfgToThemeCdnPath('/comments/Like.png'),
    SmileIconComment: cfgToThemeCdnPath('/comments/Smile.png'),
    ArrowIconComment: cfgToThemeCdnPath('/comments/arrow.svg'),
    ReplyIconComment: cfgToThemeCdnPath('/comments/reply.png'),
    SimilarIconComment: cfgToThemeCdnPath('/comments/similar.svg')
};
